import { createApp } from 'vue'
import App from './App.vue'
import store from './store/index'
import router from './router'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'


(async () => {
    //await store.dispatch("initAuth");
    const app = createApp(App);
    app.use(store);
    app.use(router);
    /*
    store.dispatch("loadDetectors").finally(() => {
        app.mount('#app')
    });
    */
    app.mount('#app')

})();
